// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

:root {
  --color-white: #FFFFFF;
  --color-very-light-gray: #FAFAFA;
  --color-light-light-gray: #F7F7F7;
  --color-light-gray: #EAEAEA;
  --color-mid-gray: #CECECE;
  --color-mid-mid-gray: #AEAEAE;
  --color-gray: #747474;
  --color-dark-gray: #5F5F5F;
  --color-dark-dark-gray: #2C2C2C;
  --color-black: #000000;
  --color-brand-green: #008844;
  --color-light-brand-green: #8DCD45;
  --color-brand-gradient: linear-gradient(var(--color-brand-green), var(--color-light-brand-green));
  --color-green-1: #1B9C6B;
  --color-green-2: #69BB99;
  --color-green-3: #B3DBC7;
  --color-green-4: #CCE7DA;
  --color-green-5: #E6F3EC;
  --color-dark-cyan: #13BCFF;
  --color-cyan: #5FECFD;
  --color-light-cyan: #B7F7FF;
  /* --color-light-light-cyan: rgba('#B7F7FF', 0.5); */
  --color-dark-blue: #4917B2;
  --color-blue: #829BFF;
  --color-light-blue: #B4C3FF;
  /* --color-light-light-blue */
  --color-purple: #A105C0;
  --color-violet: #E100BA;
  --color-pink: #FF95ED;
  /* --color-light-pink:  */
  --color-dark-red: #C90000;
  --color-red: #FF0000;
  --color-light-red: #FFCACA;
  /* --color-light-light-red:  */
  --color-dark-orange: #FF9632;
  --color-orange: #FDC24B;
  --color-light-orange: #FFE4AC;
  /* --color-light-light-orange:  */
  --color-dark-yellow: #DDC700;
  --color-yellow: #FFE600;
  --color-light-yellow: #FFF7AB;
  /* --color-light-light-yellow:  */
  --color-lime-green: #8DD615;
  --color-bright-green: #D9FE0E;
  --color-light-bright-green: #D9FE0E;
  /* --color-light-light-bright-green:  */
  --color-dark-turquoise: #2D938F;
  --color-turquoise: #40D9A3;
  --color-light-turquoise: #A7FFE0;
  /* --color-light-light-turquoise:  */
}

body {
  margin: 0;
  font-family: 'Roboto',  'Helvetica Neue';
}

.Mui-disabled {
  -webkit-text-fill-color: #000 !important;
}`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,iGAAiG;EACjG,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,oDAAoD;EACpD,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;EAC7B,mCAAmC;EACnC,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400&display=swap');\n\n@keyframes rotating {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n:root {\n  --color-white: #FFFFFF;\n  --color-very-light-gray: #FAFAFA;\n  --color-light-light-gray: #F7F7F7;\n  --color-light-gray: #EAEAEA;\n  --color-mid-gray: #CECECE;\n  --color-mid-mid-gray: #AEAEAE;\n  --color-gray: #747474;\n  --color-dark-gray: #5F5F5F;\n  --color-dark-dark-gray: #2C2C2C;\n  --color-black: #000000;\n  --color-brand-green: #008844;\n  --color-light-brand-green: #8DCD45;\n  --color-brand-gradient: linear-gradient(var(--color-brand-green), var(--color-light-brand-green));\n  --color-green-1: #1B9C6B;\n  --color-green-2: #69BB99;\n  --color-green-3: #B3DBC7;\n  --color-green-4: #CCE7DA;\n  --color-green-5: #E6F3EC;\n  --color-dark-cyan: #13BCFF;\n  --color-cyan: #5FECFD;\n  --color-light-cyan: #B7F7FF;\n  /* --color-light-light-cyan: rgba('#B7F7FF', 0.5); */\n  --color-dark-blue: #4917B2;\n  --color-blue: #829BFF;\n  --color-light-blue: #B4C3FF;\n  /* --color-light-light-blue */\n  --color-purple: #A105C0;\n  --color-violet: #E100BA;\n  --color-pink: #FF95ED;\n  /* --color-light-pink:  */\n  --color-dark-red: #C90000;\n  --color-red: #FF0000;\n  --color-light-red: #FFCACA;\n  /* --color-light-light-red:  */\n  --color-dark-orange: #FF9632;\n  --color-orange: #FDC24B;\n  --color-light-orange: #FFE4AC;\n  /* --color-light-light-orange:  */\n  --color-dark-yellow: #DDC700;\n  --color-yellow: #FFE600;\n  --color-light-yellow: #FFF7AB;\n  /* --color-light-light-yellow:  */\n  --color-lime-green: #8DD615;\n  --color-bright-green: #D9FE0E;\n  --color-light-bright-green: #D9FE0E;\n  /* --color-light-light-bright-green:  */\n  --color-dark-turquoise: #2D938F;\n  --color-turquoise: #40D9A3;\n  --color-light-turquoise: #A7FFE0;\n  /* --color-light-light-turquoise:  */\n}\n\nbody {\n  margin: 0;\n  font-family: 'Roboto',  'Helvetica Neue';\n}\n\n.Mui-disabled {\n  -webkit-text-fill-color: #000 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
